<template>
  <div
    class="relative flex flex-col justify-end p-16 md:min-h-[324px] md:min-w-[700px]"
  >
    <RevIllustration
      alt=""
      class="rounded-lg absolute left-0 top-0 hidden md:block"
      :height="324"
      :src="'/img/services-hub/repair-card-desktop.png'"
      :width="700"
    />
    <RevIllustration
      alt=""
      class="rounded-lg absolute left-0 top-0 md:hidden"
      :height="324"
      :src="'/img/services-hub/repair-card-mobile.png'"
      :width="700"
    />
    <div class="z-10 space-y-8">
      <div class="text-static-default-hi mood-inverse heading-3">
        {{ i18n(translations.title) }}
      </div>
      <div class="text-static-default-hi mood-inverse body-2">
        {{ i18n(translations.subTitle) }}
      </div>
    </div>

    <div class="mt-16">
      <RevButton
        class="mood-inverse"
        :icon="IconExternalLink"
        size="small"
        target="_blank"
        :to="`https://repair.evy.eu/${locale}/backmarket?utm_source=user_account_services&utm_medium=website`"
        :tracking="{
          zone: trackingZone,
          name: 'go-to-repair',
        }"
        variant="primary"
      >
        {{ i18n(translations.buttonLabel) }}
      </RevButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'
import { IconExternalLink } from '@ds/icons/IconExternalLink'

import translations from './RepairCard.translations'

const i18n = useI18n()
const locale = useI18nLocale()

defineProps<{
  trackingZone: string
}>()
</script>
